export default __webpack_public_path__ + "static/media/shape-6.f5ce9707.svg";